module.exports = __webpack_public_path__ + "img/app-1.5a261214.png";